import goodsImport from './goods_import.vue'
import TableImport from './modules/table_import.vue'

export default {
    name: 'goodsImport',
    path: 'goodsImport',
    component: goodsImport,
    children: [
        {
            path: '',
            redirect: 'tableImport'
        },
        {
            path: 'tableImport',
            component: TableImport
        }
    ]
}
